
const CONFIG = {
  completed: { className: "completed", icon: "fa-clock-rotate-left" },
  closed: { className: "applied", icon: "fa-lock" },
  rejected: { className: "rejected", icon: "fa-circle-xmark" },
  applied: { className: "applied", icon: "fa-circle-check" },
  upcoming: { className: "upcoming", icon: "fa-clock" },
  eligible: { className: "eligible", icon: "fa-circle-check" },
  "not-eligible": { className: "applied", icon: "fa-circle-xmark" },
  unavailable: { className: "applied", icon: "fa-circle-xmark" },
};

export default function TourStatusBadge({ access }) {
  const status = access?.status || "unavailable";
  const config = CONFIG[status] || CONFIG.unavailable;

  return (
    <span className={`yesno ${config.className}`}>
      <i className={`fa-solid ${config.icon}`}></i>{" "}
      {access?.statusLabel || "Unavailable"}
    </span>
  );
}
